import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var content = createRuntimeFn({defaultClassName:'content_content__1ieo1f16',variantClassNames:{animation:{'default':'content_content_animation_default__1ieo1f17',slideFromBottom:'content_content_animation_slideFromBottom__1ieo1f18',slideFromRight:'content_content_animation_slideFromRight__1ieo1f19'}},defaultVariants:{},compoundVariants:[]});
var contentRoot = createRuntimeFn({defaultClassName:'content_contentRoot__1ieo1f1a',variantClassNames:{hasAsideChild:{true:'content_contentRoot_hasAsideChild_true__1ieo1f1b'}},defaultVariants:{},compoundVariants:[]});

export { content, contentRoot };
//# sourceMappingURL=content.vanilla.mjs.map
